import React from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  matchPath,
} from "react-router-dom";
import { useSelector } from "react-redux";
import cookie from "react-cookies";
import ProtectedRoute from "../ProtectedRoute";
import SignIn from "../components/Authentication/SignIn";
import VerifyUser from "../components/Authentication/VerifyUser";
import ForgotPassword from "../components/Authentication/ForgotPassword";
import ResetPassword from "../components/Authentication/ResetPassword";
import AdminRoutes from "./Admin";
import PlatformRoutes from "./Platforms";
import Signup from "../components/Authentication/SignUp";
import SignUpDetails from "../components/Authentication/SignUpDetails";
import { ROLE } from "../constants/constants";
import { decodeToken, getRedirectByRole } from "../utils/authHeader";
import Success from "../components/Authentication/Success";
import TeamInvitationGuard from "./TeamInvitationGuard";

const AppRoutes = () => {
  const { user } = useSelector((state) => state.user);
  const location = useLocation();

  const token = cookie.load("token");
  const decoded = token ? decodeToken(token) : null;

  const effectiveUser = user || decoded || null;
  const role = effectiveUser?.role;
  const isLoggedIn = !!effectiveUser;

  const publicOnlyPaths = [
    "/",
    "/sign-in",
    "/verify",
    "/forgot-password",
    "/reset-password",
    "/sign-up",
    "/sign-up/step-1",
  ];

  const isPublicOnlyRoute =
    publicOnlyPaths.includes(location.pathname) ||
    !!matchPath("/team-member/:loguuid/:action", location.pathname);

  if (isLoggedIn && isPublicOnlyRoute) {
    return <Navigate to={getRedirectByRole(role)} replace />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Navigate
            to={isLoggedIn ? getRedirectByRole(role) : "/sign-in"}
            replace
          />
        }
      />

      <Route
        path="/sign-in"
        element={
          isLoggedIn ? (
            <Navigate to={getRedirectByRole(role)} replace />
          ) : (
            <SignIn />
          )
        }
      />

      <Route path="/verify" element={<VerifyUser />} />
      <Route path="/success" element={<Success />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/sign-up" element={<Signup />} />
      <Route path="/sign-up/step-1" element={<SignUpDetails />} />
      <Route
        path="/team-member/:loguuid/:action"
        element={<TeamInvitationGuard />}
      />

      <Route
        path="/admin/*"
        element={
          <ProtectedRoute allowedRole={ROLE.ADMIN}>
            <AdminRoutes />
          </ProtectedRoute>
        }
      />

      <Route
        path="/*"
        element={
          <ProtectedRoute allowedRole={ROLE.USER}>
            <PlatformRoutes />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
